/**
 * Created by jonas on 2022-06-15.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../../../TheCage";
import {TheCageGameMode} from "../../../server/TheCageGameMode";
import {LogLevel, NamedLogger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";


export class SanityCheckPresentation implements SimplePresentation {
    name:string = "SanityCheckPresentation";
    private logger:NamedLogger;

    constructor() {
        this.logger = new NamedLogger("Sanity Check");
        this.logger.level = LogLevel.DEV;
    }

    shouldRun():boolean {
        return NolimitConfig.isDevMode;
    }

    start(controller:SimplePresentationRunnerController):void {
        this.sanityCheckCollapsedSymbols()


        controller.finish();
    }

    private sanityCheckCollapsedSymbols() {
        if (TheCage.model.gameData.nextMode == TheCageGameMode.NORMAL) {
            const fails = TheCage.reelView.avalancheMatrixModel.sanityCheck(TheCage.model.gameData.evaluatedArea);
            if (fails.coords.length > 0) {
                this.logger.warn("FAIL - Symbols mismatch");
                this.logger.log("evaluatedArea:", TheCage.model.gameData.evaluatedArea);
                this.logger.log("fail matrix:", fails.nameMatrix);
                this.logger.log("fail list:", fails);

            }
        }

        if (TheCage.model.gameData.nextMode == TheCageGameMode.NORMAL_AVALANCHE) {
            const fails = TheCage.reelView.avalancheMatrixModel.sanityCheck(TheCage.model.gameData.symbolsAfterTumbleForClient);
            if (fails.coords.length > 0) {
                this.logger.warn("FAIL - Symbols mismatch");
                this.logger.log("symbolsAfterTumbleForClient:", TheCage.model.gameData.symbolsAfterTumbleForClient);
                this.logger.log("fail matrix:", fails.nameMatrix);
                this.logger.log("fail list:", fails);
            }
        }

        if (TheCage.reelView.multiplierDisplay.value != TheCage.model.gameData.persistantBaseMultiplier) {
            let message = `FAIL - Multiplier mismatch`;
            message += `\nmultiplierDisplay.value : ${TheCage.reelView.multiplierDisplay.value}`;
            message += `\npersistantBaseMultiplier : ${TheCage.model.gameData.persistantBaseMultiplier}`;

            this.logger.warn(message);
        }


        /*   if (Octagon.reelView.waysDisplay.value != Octagon.model.gameData.totalWays){
               let message = `FAIL - Ways Display mismatch`;
               message += `\nwaysDisplay.value : ${Octagon.reelView.waysDisplay.value}`;
               message += `\ntotalWays : ${Octagon.model.gameData.totalWays}`;

               this.logger.warn(message);
           }*/
    }


}